import { render } from "./SwitchLocale.vue?vue&type=template&id=6b44b58a&scoped=true&ts=true"
import script from "./SwitchLocale.vue?vue&type=script&lang=ts"
export * from "./SwitchLocale.vue?vue&type=script&lang=ts"

import "./SwitchLocale.vue?vue&type=style&index=0&id=6b44b58a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.9.3__webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b44b58a"]])

export default __exports__